import { cloneDeep, concat, forEach, pick, findIndex, includes, get } from 'lodash';

// local dependencies
import { WIDGET_NAMES } from 'constants/entity-names';
import * as MESSAGE_BUS_EVENTS from 'constants/message-bus-events';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { ITEM_OPERATION, REQUEST_DATA_FOR_WIDGET_SYNC } from './getWidgetData.constants';

/**
 * @type {function}
 * @desc Resolvers are pure functions used for resolving templates (React components) or to transform some data.
 * A resolver function takes an `id` and an optional `payload` and returns a `result`.
 * Based on `switch` cases inside this function, correct `result` should be returned.
 * @param {object} payload
 * @example
 * import { getWidgetData } from 'resolvers/getWidgetData';
 */
export const getWidgetData = async ( { message, url, initialState, serviceInstance } ) => {
    const { widgetName, requestType, requestData, context, itemOperation } = message;
    const newState = cloneDeep( initialState );

    switch( widgetName ) {

        case WIDGET_NAMES.MEMBER_DETAILS_ALERTS_STATS: {

            if( MESSAGE_BUS_EVENTS.WIDGET_RELOAD_REQUEST === requestType ) {

                try {
                    const { status, data: newData } = await serviceInstance.fetchComponentData( {
                        url,
                        data: { context: context }
                    } );

                    if ( isSuccess( status ) ) {
                        newState.componentData = newData;
                    }

                    return newState;

                } catch ( error ) {
                    return newState;
                }
            }

            break;
        }

        case WIDGET_NAMES.MEMBER_ALERTS_LISTING: {

            if( MESSAGE_BUS_EVENTS.WIDGET_SYNC_REQUEST === requestType ) {

                if ( ITEM_OPERATION.ADD === itemOperation ) {


                    // toDo remove this check when "Delete" operation type is created by Backend @requested by aakash
                    let dataItemPresent = false;

                    forEach( newState.componentData.alertTypes, alertType => { // check if itemIds already present
                        const alertTypeName = alertType.name;
                        
                        const _dataFound = findIndex( get( newState.componentData, `state[${ alertTypeName }]`, [] ), ( o ) => { return includes( requestData.itemIds, o.id ); } );
                        if( -1 !== _dataFound ) {
                            dataItemPresent = true;
                        }
                    } );

                    if( dataItemPresent ) { // if data Id Already present don't do anything
                        return newState;
                    }

                    try {
                        const { status, data: newData } = await serviceInstance.fetchSyncData( {
                            url,
                            data: {
                                context,
                                data: pick( requestData, REQUEST_DATA_FOR_WIDGET_SYNC[ WIDGET_NAMES.MEMBER_ALERTS_LISTING ] )
                            }
                        } );
    
                        if ( isSuccess( status ) ) {
                            forEach( newState.componentData.alertTypes, alertType => {
                                const alertTypeName = alertType.name;
                                
                                newState.componentData.state[ alertTypeName ] = concat(
                                    newState.componentData.state[ alertTypeName ], newData.state[ alertTypeName ]
                                );
                            } );
                        }

                        return newState;
    
                    } catch ( error ) {
                        return newState;
                    }
                }
            }

            break;
        }

        default: {
            return newState;
        }
    }
};

/**
 * This function returns true, if status is 'success'
 * @param {string} status - string value of status key in JSON response
 */
const isSuccess = ( status ) => status === SERVICE_RESPONSE_STATUS.SUCCESS;
